import { render, staticRenderFns } from "./MissingReviewsItem.vue?vue&type=template&id=7cbfc37f&scoped=true&"
import script from "./MissingReviewsItem.vue?vue&type=script&lang=js&"
export * from "./MissingReviewsItem.vue?vue&type=script&lang=js&"
import style0 from "./MissingReviewsItem.vue?vue&type=style&index=0&id=7cbfc37f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbfc37f",
  null
  
)

export default component.exports